import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/Home'
import ListView from '@/views/List'
import DetailView from '@/views/Detail'
import PageView from '@/views/Page'
import PageDetailView from '@/views/PageDetail'

import { useCookies } from '@vueuse/integrations'
import api from '@/services'

const routes = [

    {
        path: '/search',
        name: 'search',
        component: ListView
    },
    {
        path: '/pages/:slug',
        name: 'pages',
        component: PageView
    },
    {
        path: '/pages/:path([a-zA-Z0-9-/]+)/:slug([a-zA-Z0-9-/]+)/:pk(\\d+)',
        name: 'pagedetail',
        component: PageDetailView
    },
    {
        path: '/list/:slug',
        name: 'list',
        component: ListView
    },
    {
        path: '/:slug([a-zA-Z0-9-/]+)/:pk(\\d+)',
        name: 'detail',
        component: DetailView
    },
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

const cookies = useCookies(['token'])

async function getAuthorization()
{
    sessionStorage.removeItem('user-data')
    const res = await api.auth.getAuthorizationUrl()
    if(res.status == 200)
        location = res.data.authorization_url
}

async function fetchUserData()
{
    let response = null
    try {
        response = await api.auth.getUserData()
        const userData = response.data

        if ( Object.keys(userData).length === 0 )
            throw "No user data"

        sessionStorage.setItem('user-data', JSON.stringify(userData))
    }
    catch (error) {
        cookies.remove('MPTO.SSO.Token')
        getAuthorization()
    }
}

router.beforeEach( async (to, from, next) => {
    const mpeToken = cookies.get('MPTO.SSO.Token')

    if(!mpeToken)
    {
        next(false)
        await getAuthorization()
    }

    else
    {
        await fetchUserData()
        next()
    }
})

export default router
